import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dr-video',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './dr-video.component.html',
  styleUrl: './dr-video.component.scss'
})
export class DrVideoComponent implements OnInit {
  videoUrl: SafeResourceUrl | null = null;
  isLoading = true;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router
  ) {}

  ngOnInit(): void {
    const url = history.state?.videoUrl;
    if (url) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    this.isLoading = false;
  }

  goBack(): void {
    this.router.navigate(['/service/433']);
  }
}
